import { alpha, type Theme, type ThemeOptions } from '@mui/material/styles';

const NEUTRAL_TEXT = '#555F6C';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function colorVariant(variantName: string, color: string): Record<string, any> {
  return {
    [`&.SmChip-variant-${variantName}.SmChip-style-filled`]: {
      backgroundColor: alpha(color, 0.16),
      color,
      border: '1px solid transparent'
    },
    [`&.SmChip-variant-${variantName}.SmChip-style-outlined`]: {
      backgroundColor: 'transparent',
      color,
      border: `1px solid ${color}`
    }
  };
}

export function chipThemeComponents(theme: Theme): ThemeOptions['components'] {
  return {
    MuiChip: {
      styleOverrides: {
        root: {
          '&.SmChip-root': {
            fontWeight: 400,
            paddingInline: 6,
            boxSizing: 'border-box',

            '&.SmChip-deletable': {
              justifyContent: 'flex-start',
              '& .MuiChip-label': {
                textAlign: 'right',
                paddingRight: 10,
                paddingLeft: 0
              }
            },

            '& .MuiChip-label': {
              paddingLeft: 10,
              paddingRight: 10
            },

            '& .SmChip-icon': {
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginLeft: 6,
              marginRight: -4,

              '& .MuiSvgIcon-root, & > svg': {
                fontSize: 13
              }
            },

            '& .MuiChip-deleteIcon': {
              order: -1,
              marginRight: 10,
              marginLeft: 2,
              color: theme.palette.common.white,

              fontSize: 13,
              backgroundColor: '#a0acc0',
              borderRadius: 6,
              padding: 2,
              boxSizing: 'border-box',
              '&.MuiSvgIcon-root': {
                fontSize: 13,
                backgroundColor: '#a0acc0',
                borderRadius: 6,
                padding: 2,
                color: theme.palette.common.white
              },
              '& .MuiSvgIcon-root, & > svg': { fontSize: 13, color: theme.palette.common.white }
            },

            '&.MuiChip-sizeSmall': {
              height: 26,
              fontSize: 13
            },

            '&.MuiChip-sizeMedium': {
              height: 30,
              fontSize: 13
            },

            '&.SmChip-style-filled': {
              border: '1px solid transparent'
            },

            '&.SmChip-style-outlined': {
              backgroundColor: 'transparent',
              border: `1px solid ${theme.palette.divider}`
            },

            // Every variant is written as one self-contained rule per filled/outlined
            // combo (not layered on top of `.SmChip-style-*`) so there's no cross-rule
            // specificity to reason about — every property a variant needs is set right here.
            '&.SmChip-variant-primary.SmChip-style-filled': {
              backgroundColor: '#F2F4F9',
              color: '#1E2A3A',
              border: '1px solid transparent'
            },
            '&.SmChip-variant-primary.SmChip-style-outlined': {
              backgroundColor: 'transparent',
              color: '#1E2A3A',
              border: `1px solid ${theme.palette.divider}`
            },

            ...colorVariant('secondary', theme.palette.secondary.main),
            ...colorVariant('success', theme.palette.success.main),
            ...colorVariant('error', theme.palette.error.main),
            ...colorVariant('info', theme.palette.info.main),
            ...colorVariant('warning', theme.palette.warning.main),

            '&.SmChip-variant-neutral.SmChip-style-filled': {
              backgroundColor: theme.palette.grey[200],
              color: NEUTRAL_TEXT,
              border: '1px solid transparent'
            },
            '&.SmChip-variant-neutral.SmChip-style-outlined': {
              backgroundColor: 'transparent',
              color: NEUTRAL_TEXT,
              border: `1px solid ${theme.palette.divider}`
            }
          }
        }
      }
    }
  };
}

